import { render, staticRenderFns } from "./VueInfiniteLoader.vue?vue&type=template&id=d12c0d6c&scoped=true"
import script from "./VueInfiniteLoader.vue?vue&type=script&lang=js"
export * from "./VueInfiniteLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12c0d6c",
  null
  
)

export default component.exports